import {
  COLOR,
  MarginKey,
  MarginRecord,
  NormalizedSpacingKey,
  NormalizedSpacingRecord,
  PaddingKey,
  PaddingRecord,
} from './type';

const MARGIN_KEY_MAPPING: Record<NormalizedSpacingKey, MarginKey> = {
  [NormalizedSpacingKey.Bottom]: MarginKey.Bottom,
  [NormalizedSpacingKey.Left]: MarginKey.Left,
  [NormalizedSpacingKey.Right]: MarginKey.Right,
  [NormalizedSpacingKey.Top]: MarginKey.Top,
};

const PADDING_KEY_MAPPING: Record<NormalizedSpacingKey, PaddingKey> = {
  [NormalizedSpacingKey.Bottom]: PaddingKey.Bottom,
  [NormalizedSpacingKey.Left]: PaddingKey.Left,
  [NormalizedSpacingKey.Right]: PaddingKey.Right,
  [NormalizedSpacingKey.Top]: PaddingKey.Top,
};

const COLOR_MAP: Record<COLOR, string> = {
  [COLOR.Black]: 'var(--black)',
  [COLOR.Dark1]: 'var(--dark1)',
  [COLOR.Dark2]: 'var(--dark2)',
  [COLOR.Dark3]: 'var(--dark3)',
  [COLOR.Gold1]: 'var(--gold1)',
  [COLOR.Gold2]: 'var(--gold2)',
  [COLOR.Gray1]: 'var(--gray1)',
  [COLOR.Gray2]: 'var(--gray2)',
  [COLOR.Gray3]: 'var(--gray3)',
  [COLOR.Highlight]: 'var(--highlight)',
  [COLOR.White]: 'var(--white)',
};

export function createMarginRecord(record: NormalizedSpacingRecord): MarginRecord {
  const margin: MarginRecord = {};
  Object.values(NormalizedSpacingKey).forEach(key => {
    const k = MARGIN_KEY_MAPPING[key];
    if (record[key] !== undefined) {
      margin[k] = record[key];
    }
  });
  return margin;
}

export function createPaddingRecord(record: NormalizedSpacingRecord): PaddingRecord {
  const padding: PaddingRecord = {};
  Object.values(NormalizedSpacingKey).forEach(key => {
    const k = PADDING_KEY_MAPPING[key];
    if (record[key] !== undefined) {
      padding[k] = record[key];
    }
  });
  return padding;
}

export function colorToCss(color?: COLOR): string | undefined {
  return color ? COLOR_MAP[color] : undefined;
}
